import { render, staticRenderFns } from "./AnnouncementsView.vue?vue&type=template&id=054c29c9&scoped=true&"
import script from "./AnnouncementsView.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsView.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsView.vue?vue&type=style&index=0&id=054c29c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c29c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCol,VContainer,VDivider,VIcon,VRow})
